import camelCase from "lodash/camelCase";

export const higherCaseToCamelCase = (str: string) => {
    return camelCase(str);
};
